/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import { Button, Text } from 'src/@vymo/ui/atoms';
import { List, Popup, TabLayout } from 'src/@vymo/ui/blocks';
import { getSelectedMenu } from 'src/models/lmsConfig/selectors';
import { getModuleButtons } from 'src/models/moduleButtons/selectors';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { handleModuleNavigation } from './queries';
import type { ExtendedNavigationItem } from './types';
import styles from './index.module.scss';

function NavigationV2() {
  const selectedMenu = useAppSelector(getSelectedMenu);
  const dispatch = useAppDispatch();
  const [activeMenu, setActiveMenu] = useState<{
    menu: ExtendedNavigationItem | null;
    type: 'direct' | 'parent';
  }>({
    menu: (selectedMenu?.menu?.items?.length
      ? selectedMenu?.menu?.items?.[0]
      : selectedMenu?.menu) as ExtendedNavigationItem | null,
    type: selectedMenu.type,
  });
  const moduleButtons = useAppSelector(getModuleButtons);

  useEffect(() => {
    if (activeMenu?.menu && activeMenu.type === 'direct') {
      handleModuleNavigation(activeMenu?.menu, dispatch);
    }
  }, [activeMenu, dispatch]);

  useEffect(() => {
    setActiveMenu({
      menu: (selectedMenu?.menu?.items?.length
        ? selectedMenu?.menu?.items?.[0]
        : selectedMenu?.menu) as ExtendedNavigationItem | null,
      type: selectedMenu.type,
    });
  }, [selectedMenu]);

  if (!selectedMenu?.menu) return null;

  return (
    <div className={styles.navigationV2}>
      <div className={styles.navigationV2__title}>
        <Text type="h4">{selectedMenu?.menu?.name}</Text>
        {moduleButtons.length > 0 && (
          <div className={styles.navigationV2__buttons}>
            {moduleButtons.map((button) =>
              button.type === 'popup' ? (
                button.children?.length ? (
                  <Popup
                    content={
                      <List
                        onItemClick={(idx) =>
                          button?.children?.[idx]?.onClick?.()
                        }
                        className={styles.navigationV2__buttons__popupList}
                      >
                        {(button?.children || []).map((child) => (
                          <List.Item
                            key={child?.code}
                            className={
                              styles.navigationV2__buttons__popupList__item
                            }
                          >
                            {child.icon}
                            <Text>{child?.label}</Text>
                          </List.Item>
                        ))}
                      </List>
                    }
                    placement="bottom"
                    closeTrigger="click"
                  >
                    <Button
                      key={button.label}
                      variant={button.variant}
                      disabled={button.disabled}
                      className={styles.navigationV2__buttons__button}
                      iconProps={{
                        icon: button.icon,
                        iconPosition: 'left',
                      }}
                    >
                      {button.label}
                    </Button>
                  </Popup>
                ) : null
              ) : (
                <Button
                  key={button['data-test-id'] || button.label}
                  variant={button.variant}
                  disabled={button.disabled}
                  onClick={button.onClick}
                  data-test-id={button['data-test-id']}
                  className={styles.navigationV2__buttons__button}
                  iconProps={{
                    icon: button.icon,
                    iconPosition: 'left',
                  }}
                >
                  {button.label}
                </Button>
              ),
            )}
          </div>
        )}
      </div>
      {selectedMenu?.menu?.items && (
        <TabLayout
          items={selectedMenu?.menu?.items.map((item) => ({
            ...item,
            label: item.name || '',
            key: item.key || '',
          }))}
          defaultKey={selectedMenu?.menu?.items[0].key || ''}
          onChange={(key, item) =>
            setActiveMenu({
              menu: item as ExtendedNavigationItem,
              type: 'direct',
            })
          }
        />
      )}
    </div>
  );
}

export default NavigationV2;
